import type { User } from "@/hooks/useUser";

const ACCESS_GRANTING_SUBSCRIPTION_STATUSES = new Set(['ACTIVE', 'TRIALING']);

export const userHasPaidAccess = (user: User | undefined) => {
  if (!user) return false;

  // If a license was allocated (e.g. a family member invited onto a plan), they should be allowed in.
  if (user.license === 'PAID') return true;

  const subs: any[] = (user.subscriptions ?? []) as any[];
  return subs.some((sub) => {
    const status = String(sub?.status ?? '').toUpperCase();
    const quantity = typeof sub?.quantity === 'number' ? sub.quantity : Number(sub?.quantity ?? 0);
    return ACCESS_GRANTING_SUBSCRIPTION_STATUSES.has(status) && quantity > 0;
  });
};

export const getUserLicenseQuantity = (user: User | undefined) => {
  if (!user || !user.subscriptions || user.subscriptions.length === 0) {
    return 0;
  }

  // Only count subscriptions that are not cancelled
  return user.subscriptions
    .filter(sub => sub.status !== 'CANCELED')
    .reduce((acc, subscription) => acc + subscription.quantity, 0) ?? 0;
};

export const calculateUsedLicenses = (user: User | undefined) => {
  if (!user || !user.subscriptions || user.subscriptions.length === 0) {
    return 0;
  }
  // Only count if there is at least one active (not cancelled) subscription
  const hasActiveSub = user.subscriptions.some(sub => sub.status !== 'CANCELED');
  if (!hasActiveSub) return 0;

  const ownLicenseActive = user.license === 'PAID' ? 1 : 0;
  const childUsers = user.childUsers ?? [];
  const childUsersActiveLicenses = childUsers.filter(child => child.license === 'PAID').length;

  return ownLicenseActive + childUsersActiveLicenses;
};


